app.component("paymentTransactionsView", {
    templateUrl: "app/src/js/components/paymentTransactions/payment-transactions.tmpl.html",
    controller: "paymentTransactionsController",
    bindings: {
        onCancel: "&",
    },
});

app.controller("paymentTransactionsController", [
    "$scope",
    "$timeout",
    "$q",
    "$mdDialog",
    "PaymentTransactionsAPI",
    "TranscriptionSeatsAPI",
    "$modal",
    "Session",
    "ENV",
    "countryConfig",
    function ($scope, $timeout, $q, $mdDialog, PaymentTransactionsAPI, TranscriptionSeatsAPI, $modal, Session, ENV, countryConfig) {
        $scope.Session = Session;
        $scope.API = PaymentTransactionsAPI;
        $scope.isLoading = true;
        $scope.viewState = 'DASHBOARD';
        $scope.errorMessage = null;
        $scope.successMessage = null;
        $scope.elevenLabsAiAgentFeatureEnabled = false;
        $scope.appointmentSMSReminderFeatureEnabled = false;

        // Every NZ practice has transcription and no AU practice does, so this is settled by
        // country rather than by a per-practice flag. See countryConfig.provider.
        $scope.transcriptionEnabled = countryConfig.transcriptionFeatureEnabled;

        if ($scope.Session.practice && $scope.Session.practice.practiceFeatures) {
            $scope.elevenLabsAiAgentFeatureEnabled = ($scope.Session.practice.practiceFeatures.elevenLabsAiAgentFeature);
            $scope.appointmentSMSReminderFeatureEnabled = ($scope.Session.practice.practiceFeatures.appointmentSMSReminderFeature);
        }

        // Tab State
        $scope.selectedTabIndex = 0;
        $scope.currentCardView = 'PRIMARY'; // 'PRIMARY' or 'BACKUP'

        /** The section of the seats tab the wallet tab last linked to. A fresh object per request. */
        $scope.seatsRequest = null;

        // Lets the seats tab send the user back here for the card and top-up actions.
        $scope.goToWalletTab = function () {
            $scope.selectedTabIndex = 0;
        };

        /**
         * Sends the user to the seats tab, landing on one of its sections.
         * @param {string} [view] BUY | ASSIGN | USAGE. Omit to let that tab choose.
         */
        $scope.goToSeatsTab = function (view) {
            // A new object every time, so following the same link twice still moves the child's view.
            $scope.seatsRequest = { view: view || null };
            $scope.selectedTabIndex = 1;
        };

        // Usage Data
        $scope.usageHistory = [];
        $scope.isLoadingUsage = false;

        // Wallet State mapped to your new JSON Schema
        $scope.wallet = {
            balance_tokens: 0,
            is_auto_reload_enabled: false,
            reload_threshold_tokens: 20,
            reload_amount_tokens: 100,
            // Primary Card
            default_payment_method_id: null,
            card_brand: null,
            card_last4: null,
            card_exp_month: null,
            card_exp_year: null,
            // Backup Card
            backup_payment_method_id: null,
            backup_card_brand: null,
            backup_card_last4: null,
            backup_card_exp_month: null,
            backup_card_exp_year: null
        };

        /**
         * Enough of the seat product to advertise it alongside the wallet: the purchasable tiers with
         * their prices, and whatever the practice already holds.
         *
         * Loaded here rather than read off the seats tab because that tab is only compiled once it is
         * opened, and the whole point of the panel is to reach a practice that has never opened it.
         * Every figure shown comes back from the server; nothing about a price is worked out here.
         */
        $scope.seatPromo = {
            isLoading: false,
            hasFailed: false,
            plans: [],
            subscription: null,
            badge: { text: 'NEW', state: '' }
        };

        /**
         * Pulses the seats panel once, as the dialog first shows it. The panel sits below the wallet
         * card, where the eye does not land on its own, and a practice paying per transcribed minute
         * has nothing else prompting it to compare the two. Dropped again as the animation finishes,
         * so a wallet refresh later in the same session does not pulse at someone who has seen it.
         */
        $scope.highlightSeatPromo = false;
        let hasHighlightedSeatPromo = false;

        function highlightSeatPromoOnce() {
            if (hasHighlightedSeatPromo || !$scope.transcriptionEnabled) {
                return;
            }

            hasHighlightedSeatPromo = true;
            $scope.highlightSeatPromo = true;

            // Outlasts the ping in _transcription-seats.css, whose last sweep ends at 2.5s.
            $timeout(() => {
                $scope.highlightSeatPromo = false;
            }, 2700);
        }

        let stripe = null;
        let elements = null;
        let cardElement = null;

        // =================================================================
        // Lifecycle & Init
        // =================================================================
        this.$onInit = function () {
            $scope.$mdDialog = $mdDialog;
            fetchWalletStatus();
            fetchUsageHistory();

            if ($scope.transcriptionEnabled) {
                fetchSeatPromo();
            }

            if (typeof Stripe !== 'undefined') {
                stripe = Stripe(ENV.STRIPE_CARD_INITIATE_KEY);
                elements = stripe.elements();
            }
        };

        // Seats bought on the seats tab change what this panel should say, so the counts are re-read
        // on any return to this tab rather than left as they were when the dialog opened.
        $scope.$watch('selectedTabIndex', function (index, previousIndex) {
            if (index !== 0 || index === previousIndex || !$scope.transcriptionEnabled) {
                return;
            }

            refreshSeatSubscription();
        });

        function fetchWalletStatus() {
            $scope.isLoading = true;
            return $scope.API.getWalletStatus()
                .then((response) => {
                    $timeout(() => {
                        $scope.wallet = response.data;
                    });
                })
                .catch((err) => {
                    console.error("Failed to load wallet", err && err.status);
                    $scope.errorMessage = "Could not load wallet details.";
                })
                .finally(() => {
                    $timeout(() => {
                        $scope.isLoading = false;

                        // Only now does the panel exist to be pulsed: it is behind this load.
                        highlightSeatPromoOnce();
                    });
                });
        }

        function fetchUsageHistory() {
            $scope.isLoadingUsage = true;
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(startDate.getDate() - 30);

            $scope.API.getPaymentTransactions(startDate.toISOString(), endDate.toISOString())
                .then((response) => {
                    $scope.usageHistory = (response.data || []).map(tx => ({
                        date: new Date(tx.date_created),
                        type: tx.payment_transaction_type,
                        status: tx.status,
                        description: tx.details,
                        tokens: tx.tokens_processed,
                        balanceAfter: tx.new_token_balance,
                        stripeId: tx.stripe_reference_id
                    }));
                })
                .catch((err) => {
                    console.error("Failed to load transactions", err && err.status);
                    $scope.errorMessage = "Unable to load transaction history.";
                })
                .finally(() => {
                    $scope.isLoadingUsage = false;
                });
        }

        // =================================================================
        // AI Transcription Seats: the panel advertising them on this tab
        // =================================================================

        function fetchSeatPromo() {
            $scope.seatPromo.isLoading = true;
            $scope.seatPromo.hasFailed = false;

            return $q
                .all({
                    plans: TranscriptionSeatsAPI.getSeatPlans(),
                    subscription: TranscriptionSeatsAPI.getSubscription()
                })
                .then((responses) => {
                    const plans = responses.plans.data || {};

                    $scope.seatPromo.plans = plans.plans || [];

                    applySeatSubscription(responses.subscription.data);
                })
                .catch(() => {
                    // The panel still describes the product and still links across; the seats tab
                    // itself reports a failure properly once the user gets there.
                    $scope.seatPromo.hasFailed = true;
                })
                .finally(() => {
                    $timeout(() => {
                        $scope.seatPromo.isLoading = false;
                    });
                });
        }

        /** Only the counts can have moved while the user was on the seats tab, not the price list. */
        function refreshSeatSubscription() {
            return TranscriptionSeatsAPI.getSubscription()
                .then((response) => {
                    $timeout(() => {
                        applySeatSubscription(response.data);
                    });
                })
                .catch(() => {
                    // Leave the counts as they were: a stale number reads better than an empty panel.
                });
        }

        function applySeatSubscription(subscription) {
            $scope.seatPromo.subscription = subscription || null;
            $scope.seatPromo.badge = getSeatBadge();
        }

        /**
         * What the panel's badge says. A subscription needing attention is named rather than flattened
         * into "active", because the card it is failing against is on this very tab.
         */
        function getSeatBadge() {
            const subscription = $scope.seatPromo.subscription;

            if (!$scope.hasSeatSubscription()) {
                return { text: 'NEW', state: '' };
            }

            if (subscription.status === 'PAST_DUE') {
                return { text: 'PAYMENT DUE', state: 'alert' };
            }

            if (subscription.cancel_at_period_end) {
                return { text: 'ENDING', state: '' };
            }

            return { text: 'ACTIVE', state: 'live' };
        }

        $scope.fromCents = TranscriptionSeatsAPI.fromCents;
        $scope.formatAllowanceHours = TranscriptionSeatsAPI.formatAllowanceHours;

        $scope.hasSeatSubscription = function () {
            return TranscriptionSeatsAPI.isSubscriptionLive($scope.seatPromo.subscription);
        };

        $scope.getSeatsOwned = function () {
            return getSeatTotal('quantity_owned');
        };

        $scope.getSeatsAssigned = function () {
            return getSeatTotal('quantity_assigned');
        };

        /** Seats already paid for that nobody is using, which is the one number worth acting on here. */
        $scope.getSeatsUnassigned = function () {
            return Math.max(0, $scope.getSeatsOwned() - $scope.getSeatsAssigned());
        };

        function getSeatTotal(field) {
            const subscription = $scope.seatPromo.subscription;

            if (!subscription || !subscription.seats) {
                return 0;
            }

            return subscription.seats.reduce((total, seat) => total + (seat[field] || 0), 0);
        }

        /**
         * The single thing worth saying under the panel, or null. Ordered by how much it costs the
         * practice to ignore: a blocked service, then seats being paid for and wasted, then the card
         * that has to exist before any of it can be bought.
         */
        $scope.getSeatPromoNote = function () {
            const subscription = $scope.seatPromo.subscription;

            if (subscription && (subscription.status === 'PAST_DUE' || subscription.status === 'UNPAID')) {
                return 'OVERDUE';
            }

            if (subscription && subscription.orphaned_seat_count > 0) {
                return 'ORPHANED';
            }

            if (!$scope.wallet.default_payment_method_id) {
                return 'NO_CARD';
            }

            return null;
        };

        // =================================================================
        // Actions: Settings & Card Management
        // =================================================================

        $scope.saveStatus = '';
        $scope.autoSaveSettings = function () {
            // Requirement: Must have a primary payment method to enable auto-reload
            if (!$scope.wallet.default_payment_method_id) return;

            if ($scope.wallet.reload_threshold_tokens == null || $scope.wallet.reload_amount_tokens == null ||
                $scope.wallet.reload_threshold_tokens < 0 || $scope.wallet.reload_amount_tokens <= 0) {
                return;
            }

            $scope.saveStatus = 'Saving...';
            $scope.API.updateWalletSettings({
                is_auto_reload_enabled: $scope.wallet.is_auto_reload_enabled,
                reload_threshold_tokens: $scope.wallet.reload_threshold_tokens,
                reload_amount_tokens: $scope.wallet.reload_amount_tokens
            })
                .then(() => {
                    $scope.topupAmount = $scope.wallet.reload_amount_tokens - $scope.wallet.balance_tokens;
                    $scope.saveStatus = 'All changes saved';
                    $timeout(() => { $scope.saveStatus = ''; }, 3000);
                })
                .catch((err) => {
                    $scope.saveStatus = 'Error saving settings';
                });
        };

        $scope.removeCard = function () {
            const type = $scope.currentCardView;
            const pmId = (type === 'PRIMARY') ? $scope.wallet.default_payment_method_id : $scope.wallet.backup_payment_method_id;

            if (!pmId) return;

            $scope.API.isProcessing = true;
            $scope.API.deletePaymentMethod(pmId)
                .then(() => {
                    $scope.successMessage = (type === 'PRIMARY' ? "Primary" : "Backup") + " card removed.";
                    return fetchWalletStatus();
                })
                .catch((err) => {
                    alert("Failed to remove card. Please try again.");
                })
                .finally(() => {
                    $timeout(() => {
                        $scope.API.isProcessing = false;
                    });
                });
        };

        // =================================================================
        // Manual Top Up & Transaction Polling
        // =================================================================

        $scope.manualTopUp = function () {
            if (!$scope.wallet.default_payment_method_id) return;

            // 1. Setup the modal scope
            var modalScope = $scope.$new();

            // 2. Define the confirm action
            modalScope.onGeneralClick = function () {
                // Close modal immediately
                if ($scope.generalModal) {
                    $scope.generalModal.hide();
                }

                $scope.errorMessage = null;
                $scope.API.isProcessing = true; // Start global spinner

                // 3. Perform the API Call
                PaymentTransactionsAPI.topupPracticeBalance()
                    .then(function (response) {
                        const txId = response.data.transaction_id;
                        if (!txId) throw new Error("No transaction ID returned from server.");

                        // 4. Start Polling
                        return pollTransactionStatus(txId);
                    })
                    .then(function (transaction) {
                        // 5. Success
                        $scope.successMessage = "Balance topped up successfully!";
                        fetchWalletStatus(); // Refresh wallet
                        fetchUsageHistory(); // Refresh table

                        $timeout(function () { $scope.successMessage = null; }, 4000);
                    })
                    .catch(function (err) {
                        // 6. Error Handling
                        console.error("Top Up Flow Error:", err && (err.status || err.message));

                        // The dialog has gone; there is nothing left to refresh or report into.
                        if ($scope.$$destroyed) return;

                        // We still refresh usage/wallet in case it partially succeeded or failed
                        fetchWalletStatus();
                        fetchUsageHistory();

                        // Show specific modal for failures
                        showGenericErrorModal(err.message || "The top-up attempt failed. Please check your card.");
                    })
                    .finally(function () {
                        // 7. Always turn off the spinner
                        $timeout(function () {
                            $scope.API.isProcessing = false;
                        });
                    });
            };

            // 8. Open the Confirmation Modal
            $scope.generalModal = $modal({
                scope: modalScope,
                templateUrl: "app/src/views/templates/modal.general.tpl.html",
                show: true,
                title: "Top up balance",
                content: "Are you sure you want to purchase " + $scope.wallet.reload_amount_tokens + " tokens? This will charge your primary card.",
                backdrop: true,
                keyboard: false,
            });
        };

        // =================================================================
        // Polling Helper (Pure Logic)
        // =================================================================

        function pollTransactionStatus(transactionId) {
            return new Promise(function (resolve, reject) {
                let attempts = 0;
                const maxAttempts = 10; // 20 seconds total (10 x 2s)
                const interval = 2000;

                const checkStatus = function () {
                    // Safety: Stop polling if user navigates away (scope destroyed)
                    // Rejected rather than left pending, so the caller's finally still clears the shared
                    // isProcessing flag - otherwise the wallet reopens with every action disabled.
                    if ($scope.$$destroyed) {
                        reject(new Error("Stopped checking the top-up because the wallet was closed."));
                        return;
                    }

                    attempts++;

                    // Optimization: Only fetch last 1 hour of transactions, not 24h
                    const end = new Date();
                    const start = new Date();
                    start.setHours(start.getHours() - 1);

                    PaymentTransactionsAPI.getPaymentTransactions(start.toISOString(), end.toISOString())
                        .then(function (response) {
                            const transactions = response.data || [];

                            // Loose comparison (==) in case ID is string in one place and int in another
                            const tx = transactions.find(function (t) {
                                return t.id == transactionId || t.transaction_id == transactionId;
                            });

                            if (tx) {
                                if (tx.status === 'SUCCESS') {
                                    resolve(tx);
                                } else if (tx.status === 'FAILED') {
                                    reject(new Error("Transaction was declined by the bank or failed."));
                                } else {
                                    // Still PENDING/PROCESSING
                                    continuePolling();
                                }
                            } else {
                                // Not found yet (Eventual Consistency)
                                continuePolling();
                            }
                        })
                        .catch(function (err) {
                            // API Failure (Network blip?), keep trying
                            continuePolling();
                        });
                };

                const continuePolling = function () {
                    if (attempts >= maxAttempts) {
                        reject(new Error("Transaction timed out. Please check your balance shortly."));
                    } else {
                        $timeout(checkStatus, interval);
                    }
                };

                // Start immediately
                checkStatus();
            });
        }

        // =================================================================
        // UI Utilities
        // =================================================================

        function showGenericErrorModal(message) {
            if ($scope.serverErrorModal) {
                $scope.serverErrorModal.hide();
            }

            // Important: Explicitly set message on scope for the template to read
            $scope.alertMessage = message;

            $scope.serverErrorModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                show: true,
                title: "Transaction Error", // Customized title
                keyboard: false,
                backdrop: "static",
                onHide: function () {
                    angular.element("body").removeClass("modal-open").css("overflow", "auto");
                    $scope.alertMessage = null; // Cleanup
                },
            });
        }

        // =================================================================
        // View Management & Stripe
        // =================================================================

        $scope.setViewState = function (state) {
            $scope.viewState = state;
            $scope.errorMessage = null;

            if (state === 'ADD_CARD') {
                $timeout(() => {
                    if (cardElement) {
                        cardElement.destroy();
                        cardElement = null;
                    }
                    mountStripeElement();
                }, 150);
            }
        };

        function mountStripeElement() {
            if (cardElement) return;
            // Stripe.js failed to load (blocked, offline), so there is no card field to mount.
            if (!elements) {
                $scope.errorMessage = "The card form could not be loaded. Please check your connection and try again.";
                return;
            }
            const style = {
                base: { color: "#32325d", fontFamily: '"Helvetica Neue", Helvetica, sans-serif', fontSize: "16px", "::placeholder": { color: "#aab7c4" } },
                invalid: { color: "#fa755a", iconColor: "#fa755a" }
            };
            cardElement = elements.create("card", { style: style, hidePostalCode: true });
            cardElement.mount("#card-element");
            cardElement.on('change', function (event) {
                $scope.$apply(() => { $scope.errorMessage = event.error ? event.error.message : null; });
            });
        }

        $scope.toggleCardView = function () {
            $scope.currentCardView = ($scope.currentCardView === 'PRIMARY') ? 'BACKUP' : 'PRIMARY';
            $scope.setViewState('DASHBOARD');
        };

        $scope.saveCard = () => {
            $scope.errorMessage = null;
            $scope.API.isProcessing = true;

            $scope.API.initiateCardSetup(Session.practice.id)
                .then((response) => {
                    return stripe.confirmCardSetup(response.data.clientSecret, {
                        payment_method: {
                            card: cardElement,
                            billing_details: {
                                name: (Session.user.firstName + " " + Session.user.lastName),
                                email: Session.user.email
                            },
                        },
                    });
                })
                .then((result) => {
                    if (result.error) throw new Error(result.error.message);

                    const pmId = result.setupIntent.payment_method;
                    return ($scope.currentCardView === 'PRIMARY')
                        ? $scope.API.setDefaultPaymentMethod(pmId)
                        : $scope.API.setBackupPaymentMethod(pmId);
                })
                .then(() => {
                    $scope.setViewState('DASHBOARD');
                    return fetchWalletStatus();
                })
                .catch((error) => {
                    $timeout(() => {
                        $scope.errorMessage = error.message || "An unexpected error occurred.";
                    });
                })
                .finally(() => {
                    $timeout(() => {
                        $scope.API.isProcessing = false;
                    });
                });
        };

        $scope.$on("$destroy", function () {
            if (cardElement) cardElement.destroy();
        });
    },
]);